import { nextTick } from '@vue/composition-api';
import VueI18n from 'vue-i18n';
import { PhoenixLocale } from '../model/locale';

export async function loadLocaleMessages(i18n: VueI18n, locale: PhoenixLocale): Promise<void> {
	// load locale messages with dynamic import
	const messages = await import(
		/* webpackChunkName: "locale-[request]" */ `../../../locales/${locale}.json`
	);

	// set locale and locale message
	i18n.setLocaleMessage(locale, messages.default);

	return nextTick();
}

function setI18nLanguage(i18n: VueI18n, locale: PhoenixLocale): void {
	// eslint-disable-next-line no-param-reassign
	i18n.locale = locale;
	document.querySelector('html')?.setAttribute('lang', locale);
}

export async function loadAndSetLocale(i18n: VueI18n, locale: PhoenixLocale, forceLoad = false): Promise<void> {
	if (forceLoad || !i18n.availableLocales.includes(locale)) {
		await loadLocaleMessages(i18n, locale);
	}
	setI18nLanguage(i18n, locale);
}
